import { Component, OnInit, signal } from '@angular/core';
import { OrgService } from 'app/shared/org.service';
import { Grouping } from "../../classes/grouping";
import { WindowService } from 'app/shared/window.service';
import { DataTable, IDataClassConfig } from 'app/classes/data-table/data-table';

@Component({
  selector: 'app-org-group-home',
  templateUrl: './org-group-home.component.html',
  styleUrls: ['./org-group-home.component.css'],
  standalone: false
})
export class OrgGroupHomeComponent implements OnInit {

  groupings = signal<Grouping[]>(null);

  dialogOpen = signal<'update'>(null);
  userGroup = signal<Grouping>(null);

  dataTable: DataTable;
  dataTableConfig: IDataClassConfig = {
    "title": { "valueType": "string", "title": "Group", "align": "left", "width": 400 },
    "userCount": { "valueType": "number", "title": "Users", "align": "right", "width": 70 },
    "createdAt": { "valueType": "date", "title": "Created", "align": "right" },
  };

  constructor(private orgService: OrgService, private windowService: WindowService) { }

  ngOnInit(): void {
    this.get();
  }

  get() {
    this.orgService.getGroupings().then(list => {
      this.groupings.set(list);
      this.dataTable = new DataTable({ data: list, sortedColumns: null }, this.dataTableConfig);
    });
  }

  groupClosed(ev: any) {
    this.dialogOpen.set(null);
    this.get();
  }

  showGroup(grouping: Grouping) {
    this.userGroup.set(grouping);
    this.dialogOpen.set('update');
  }

  createGroup() {
    this.userGroup.set(new Grouping());
    this.dialogOpen.set('update');
  }
}


